import React from 'react'

import { useFloorState } from '../../../../firebase/hooks/useFloor'
import { useOverlayState } from '../../../../firebase/hooks/useOverlays'
import { VideoTrack } from '../../../../MediaTracks/components/VideoTrack/VideoTrack'
import { useFullParticipantInfo } from '../../../../webrtc/webRTCRoom'
import { TrackPositioner } from '../TrackPositioner/TrackPositioner'

import './FloorCameraFeed.scss'

interface FloorCameraFeedProps {
  id: number
}

const FloorCameraFeed = ({ id }: FloorCameraFeedProps) => {
  const participant = useFullParticipantInfo(id)
  const floor = useFloorState()
  const overlay = useOverlayState()

  if (!participant?.tracks.camera) return null

  return (
    <TrackPositioner trackId={id} trackType="camera">
      <VideoTrack track={participant.tracks.camera} />
      {floor?.layout === 'panel' &&
        participant.isShowingTvCards &&
        !overlay && (
          <div className="name-tag">
            <span>{participant.name}</span>
          </div>
        )}
    </TrackPositioner>
  )
}

export { FloorCameraFeed }
